// ============================================
// ملف: src/components/Hero.js
// ============================================
import React from 'react';
import heroBg from '../assets/hero-bg.jpg'; // استبدل المسار حسب موقع الصورة لديك

const translations = {
  ar: {
    title: "نُعيد تعريف <span class='highlight'>التدوير</span><br>للمعدات الإلكترونية والأجهزة الطبية والاتصالات",
    desc: "رفاد التدوير شركة رائدة في المملكة، ومتخصصة في إعادة تدوير المخلفات التقنية والأجهزة الطبية ومعدات الاتصالات بطرق آمنة ومبتكرة",
    btnServices: "خدماتنا المتكاملة",
    btnQuote: "اطلب عرض سعر"
  },
  en: {
    title: "Redefining <span class='highlight'>Recycling</span><br> for E-Waste, Medical devices, and Telecom Materials",
    desc: "Rafad Recycling is a leading company in the Kingdom, specializing in the safe and innovative recycling of technological waste, medical devices, and communications equipment",
    btnServices: "Our Services",
    btnQuote: "Request Quote"
  }
};

const Hero = ({ currentLang }) => {
  const t = translations[currentLang];

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 dangerouslySetInnerHTML={{ __html: t.title }} />
        <p>{t.desc}</p>
        <div className="btn-group">
          <button className="btn btn-primary" onClick={() => scrollTo('services')}>
            <i className="fas fa-recycle"></i> {t.btnServices}
          </button>
          <button className="btn btn-outline" onClick={() => scrollTo('contact')}>
            <i className="fas fa-file-signature"></i> {t.btnQuote}
          </button>
        </div>
      </div>
      <style>{`
        .hero {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-image: url(${heroBg});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          padding: 2rem 1rem;
        }
        
        /* طبقة شفافة محسنة للجوال */
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          z-index: 1;
        }
        
        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 1000px;
          width: 100%;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(12px);
          border-radius: 60px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          animation: fadeUp 0.8s ease-out;
        }
        
        .hero h1 {
          font-size: 3.5rem;
          font-weight: 800;
          margin-bottom: 1.8rem;
          color: white;
          line-height: 1.3;
        }
        
        .hero h1 .highlight {
          background: linear-gradient(120deg, #71b887, #53b096);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .hero p {
          font-size: 1.2rem;
          max-width: 750px;
          margin: 0 auto;
          color: rgba(255, 255, 255, 0.95);
          line-height: 1.6;
        }
        
        .btn-group {
          display: flex;
          gap: 1.5rem;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 2.5rem;
        }
        
        .btn {
          padding: 0.9rem 2.2rem;
          border-radius: 50px;
          font-weight: 700;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          border: none;
          cursor: pointer;
          font-size: 1rem;
        }
        
        .btn-primary {
          background: linear-gradient(95deg, #53b096, #71b887);
          color: #1A374D;
        }
        
        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(83, 176, 150, 0.3);
        }
        
        .btn-outline {
          border: 2px solid #71b887;
          background: transparent;
          color: #71b887;
        }
        
        .btn-outline:hover {
          transform: translateY(-3px);
          background: rgba(113, 184, 135, 0.15);
        }
        
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* ============================================ */
        /* تحسينات الجوال */
        /* ============================================ */
        
        /* للأجهزة اللوحية (768px - 1023px) */
        @media (max-width: 1023px) {
          .hero h1 {
            font-size: 2.5rem;
          }
          
          .hero p {
            font-size: 1.1rem;
          }
          
          .hero-content {
            padding: 2.5rem;
          }
        }
        
        /* للهواتف المتوسطة والصغيرة (480px - 767px) */
        @media (max-width: 767px) {
          .hero {
            min-height: 90vh;
            padding: 1rem;
            align-items: center;
          }
          
          .hero-content {
            padding: 2rem 1.5rem;
            border-radius: 40px;
            backdrop-filter: blur(8px);
          }
          
          .hero h1 {
            font-size: 1.8rem;
            margin-bottom: 1.2rem;
          }
          
          .hero p {
            font-size: 0.95rem;
            line-height: 1.5;
            padding: 0 0.5rem;
          }
          
          .btn-group {
            gap: 1rem;
            margin-top: 2rem;
            flex-direction: column;
            align-items: stretch;
          }
          
          .btn {
            padding: 0.8rem 1.5rem;
            font-size: 0.9rem;
            justify-content: center;
          }
          
          .btn i {
            font-size: 0.9rem;
          }
        }
        
        /* للهواتف الصغيرة جداً (أقل من 480px) */
        @media (max-width: 480px) {
          .hero-content {
            padding: 1.5rem 1rem;
            border-radius: 30px;
          }
          
          .hero h1 {
            font-size: 1.5rem;
          }
          
          .hero p {
            font-size: 0.85rem;
          }
          
          .btn {
            padding: 0.7rem 1.2rem;
            font-size: 0.85rem;
          }
          
          .btn-group {
            gap: 0.8rem;
          }
        }
        
        /* للشاشات الأفقية على الجوال */
        @media (max-width: 767px) and (orientation: landscape) {
          .hero {
            min-height: auto;
            padding: 1.5rem 1rem;
          }
          
          .hero-content {
            padding: 1.2rem 1.5rem;
          }
          
          .hero h1 {
            font-size: 1.3rem;
            margin-bottom: 0.8rem;
          }
          
          .hero p {
            font-size: 0.8rem;
            margin-bottom: 0.5rem;
          }
          
          .btn-group {
            flex-direction: row;
            margin-top: 1rem;
          }
          
          .btn {
            padding: 0.5rem 1rem;
            font-size: 0.8rem;
          }
        }
        
        /* إزالة fixed background على الجوال لتحسين الأداء */
        @media (max-width: 767px) {
          .hero {
            background-attachment: scroll;
          }
        }
        
        /* دعم المتصفحات الحديثة */
        @media (min-width: 768px) {
          @supports (background-attachment: fixed) {
            .hero {
              background-attachment: fixed;
            }
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;